import React from "react";

import {
  HvDropdown,
  HvDropdownProps,
  ListValueProp,
} from "@hitachivantara/uikit-react-core";

interface DropdownColumnCellProps {
  value: ListValueProp[];
  placeholder: string;
  disabled: boolean;
  onChange?: (value: ListValueProp) => void;
  dropdownProps?: HvDropdownProps;
}

const DropdownColumnCell: React.FC<DropdownColumnCellProps> = ({
  value,
  disabled,
  onChange,
  placeholder,
  dropdownProps,
}) => {
  return (
    <>
      <HvDropdown
        onChange={(item) => {
          onChange?.(item as ListValueProp);
        }}
        placeholder={placeholder}
        disabled={disabled}
        values={value}
        disablePortal
        {...dropdownProps}
      />
    </>
  );
};

export default DropdownColumnCell;
